import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 30px;

  div.topBar {
    height: 56px;
    border-bottom: 1px solid var(--gray-border);
  }

  div.schedule {
    padding: 38px 16px 58px;

    h1 {
      text-align: left;
      font-size: 1.25rem;
      font-weight: 900;
      margin-bottom: 58px;
    }

    div.schedule-container {
      margin-bottom: 64px;

      div.schedule-controlles {
        display: flex;
        justify-content: space-between;

        margin-bottom: 26px;

        button {
          font-size: 1.5rem;
          cursor: pointer;

          background-color: var(--white);
          border: none;
        }

        button[disabled] {
          cursor: not-allowed;
        }

        p {
          font-size: 1rem;
          font-weight: 700;
        }
      }

      div.schedule-days-week {
        margin-bottom: 48px;

        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 8px;

        div.day {
          background-color: var(--gray);
          height: 64px;

          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          cursor: ${props => props.disableDayDiv ? 'not-allowed' : 'pointer'};

          p {
            text-transform: uppercase;
            font-weight: 700;
            font-size: 0.875rem;
          }

          p + p {
            margin-top: 4px;
          }
        }

        div.isSelected {
          background-color: var(--yellow-border-alert);
        }
      }

      div.schedule-hours {
        min-height: 247px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(5, 1fr);
        gap: 9px;
        position: relative;
        
        div.loading, div.unavailable {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          p {
            text-align: center;
            margin-top: 8px;
          }
        }

        button {
          height: 48px;
          background-color: var(--gray);

          display: flex;
          justify-content: center;
          align-items: center;

          border: none;

          cursor: pointer;

          font-size: 1.125rem;
          font-weight: 700;
        }

        button[disabled] {
          cursor: not-allowed;
        }

        button.isSelected {
          background-color: var(--yellow-border-alert);
        }
      }

      div.button-submit {
        width: 100%;
        height: 48px;
        /* padding-bottom: 4rem; */

        border-radius: 4px;

        background-color: var(--black-action);
        color: var(--white);
        border: 2px solid red;

        text-transform: uppercase;
        font-size: 1rem;
        font-weight: bold;

        cursor: pointer;

        transition: filter 0.2s;

        &:hover {
          filter: brightness(0.9);
        }
      }
    }
  }

  @media (min-width: 760px) {
    div.schedule-container {
      border: 1px solid var(--gray-border);
      border-radius: 5px;

      padding: 24px 32px;

      button[disabled] {
        cursor: not-allowed;
      }
    }

    div.schedule {
      div.schedule-container {
        div.schedule-days-week {
          gap: 16px;
        }

        div.schedule-hours {
          gap: 16px;
        }

        button[disabled] {
          cursor: not-allowed;
        }
      }
    }
  }
`;
